import { useTranslation } from "react-i18next";
import { FlowPageTitle, Space } from "melco-ui";
import MelcoAccountFlowLayout from "../../components/layout/MelcoAccountFlowLayout";
import { LoginForm } from "../../components/login/LoginForm";

const Login = () => {
  const { t } = useTranslation();

  return (
    <MelcoAccountFlowLayout>
      <FlowPageTitle>{t("login.title")}</FlowPageTitle>

      <Space direction="vertical" size="xlarge">
        <LoginForm />


      </Space>
    </MelcoAccountFlowLayout>
  );
};

export default Login;
